import { AdminUserOperationsWorkspace } from "@/features/admin/pages/AdminUsersPage";

export function AdminCreditsPage() {
  return <AdminUserOperationsWorkspace mode="credits" />;
}
